import { useState } from 'react';

import { MenuItem } from '@mui/material';

import SearchInput from 'components/SearchInput';
import { TableFilterRow } from 'components/TableList';
import { TextField } from 'components/TextField';
import { AllowanceStates } from 'services/api';

import { IAllowanceFiltersProps } from './types';

export const AllowanceFilters = ({
  onPageChange,
  params
}: IAllowanceFiltersProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  const [selectedStatusFilter, setSelectedStatusFilter] = useState(
    params.state || AllowanceStates.Active
  );

  const statuses = [
    ['All', Object.values(AllowanceStates).join()],
    ...Object.entries(AllowanceStates)
  ];

  return (
    <TableFilterRow>
      <SearchInput
        value={(params.search as string) || ''}
        onSearch={handleSearch}
        placeholder={'Search for employee names or emails'}
      />
      <TextField
        select
        id="status"
        name="status"
        label="Status"
        value={selectedStatusFilter}
      >
        {statuses.map(([key, value]) => (
          <MenuItem
            key={value}
            value={value}
            onClick={() => {
              if (selectedStatusFilter == value.toString()) {
                setSelectedStatusFilter('');
                onPageChange({ ['state']: undefined });
              } else {
                setSelectedStatusFilter(value.toString());
                onPageChange({ ['state']: value.toString() });
              }
            }}
          >
            {key}
          </MenuItem>
        ))}
      </TextField>
    </TableFilterRow>
  );
};
